import styled from 'styled-components';

import ChatImage from './assets/images/chat.png';

export const Wrapper = styled.article`
  display: flex;
  flex-flow: column nowrap;
  height: 100%;
  width: 100%;
`;

export const Info = styled.div`
  background: ${({ theme }) => theme.colors.premiumModalBg} url(${ChatImage}) 15px 30px / 250px
    160px no-repeat;
  flex: 0 0 230px;
  padding: 30px 15px 40px 295px;

  // @INFO styled premium guard sets up 0.5 opacity
  & > div > div {
    opacity: 1;
  }
`;

export const Preview = styled.figure`
  display: grid;
  flex: 1;
  place-items: center center;
`;

export const PreviewCaption = styled.figcaption`
  display: none;
`;
